module.exports = __webpack_public_path__ + "img/17.b3600e47.jpg";